//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { UserInfo } from './models/UserInfo';
import { Utilities } from './Utilities';

export class UsersClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/users/{icId}';
            if (icId === undefined || icId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('icId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent(String(icId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get user information
     * @return OK
     */
    async get(
        icId: string,
    ): Promise<UserInfo> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<UserInfo>(_response, false, []);
    }
}
